import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "breadcrumbs overflow-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Integrations ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "breadcrumbs__slash" }, " / ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "breadcrumbs__item" }, " New Integration ", -1)
const _hoisted_5 = { class: "dashboard__section" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Create an Integration", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Integration type ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  value: -1,
  disabled: ""
}, "Select an integration type", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Discord Guild", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Rust Server", -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Integration name ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Create integration ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_loading_button = _resolveComponent("loading-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "breadcrumbs__item",
        to: `/dashboard/${_ctx.$route.params.subdomain}/integrations`
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_3,
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("label", null, [
            _hoisted_7,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass({ 'form__input': true, 'full-width': true, 'medium-em': _ctx.type === -1 }),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type) = $event)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formError = ''))
            }, _hoisted_11, 34), [
              [_vModelSelect, _ctx.type]
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("p", { class: "form__error" }, _toDisplayString(_ctx.createIntegrationErrors.typeError), 513), [
          [_vShow, _ctx.createIntegrationErrors.typeError]
        ]),
        (_ctx.type !== _ctx.discordGuildValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("label", null, [
                _hoisted_13,
                _createVNode(_component_base_input, {
                  class: "form__input full-width",
                  placeholder: "A name to identify this integration, e.g. my Rust server",
                  type: "text",
                  error: _ctx.createIntegrationErrors.nameError,
                  modelValue: _ctx.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["error", "modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("p", { class: "form__error" }, _toDisplayString(_ctx.formError), 513), [
          [_vShow, _ctx.formError]
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_loading_button, {
            "button-type": "button--inverted",
            class: "input-button-group__button",
            loading: _ctx.loading
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ], 32)
    ])
  ]))
}